const values = {
    SourceTypes: [
        { id: 6, apiValue: 'OfficialPull', name: 'Official - Pull' },
        { id: 7, apiValue: 'OfficialPush', name: 'Official - Push' },
        { id: 3, apiValue: 'Scraper', name: 'Scaper' },
        { id: 8, apiValue: 'OddsAggregatorPull', name: 'Odds Aggregator (e.g. OM) - Pull' },
        { id: 9, apiValue: 'OddsAggregatorPush', name: 'Odds Aggregator (e.g. OM) - Push' },
        { id: 10, apiValue: 'OtherPull', name: 'Other - Pull' }
    ],
    LegacySourceTypes: [
        { apiValue: 'Unspecified', name: 'Unspecified' },
        { apiValue: 'Official', name: 'Official' },
        { apiValue: 'MBM', name: 'MBM' },
        { apiValue: 'ThirdParty', name: 'ThirdParty' }
    ],
    AvailabilityTypes: [
        { id: 1, name: "Unspecified" },
        { id: 2, name: "Yes" },
        { id: 3, name: "No" }
    ],
    Maintainers: [
        { id: 'OIS', name: 'OIS' },
        { id: 'Professional Services', name: 'Professional Services' },
        { id: 'AGS', name: 'AGS' },
        { id: 'Advance Risk', name: 'Advance Risk' },
        { id: 'Algo', name: 'Algo' },
        { id: 'Customer-Managed Integration (Ingestion API)', name: 'Customer-Managed Integration (Ingestion API)' }
    ],
    isKnownSourceType(sourceTypeNew) {
        return this.SourceTypes.some(t => t.apiValue === sourceTypeNew);
    },
    isLegacySourceType(sourceTypeNew) {
        return this.LegacySourceTypes.some(t => t.apiValue === sourceTypeNew);
    },
    getSourceTypeDisplayName(source) {
        const sourceTypeNew = source?.sourceTypeNew;
        return this.SourceTypes.find(t => t.apiValue === sourceTypeNew)?.name
            ?? this.LegacySourceTypes.find(t => t.apiValue === sourceTypeNew)?.name
            ?? '';
    },
    getSourceTypeId(sourceTypeNew) {
        return this.SourceTypes.find(t => t.apiValue === sourceTypeNew)?.id;
    }
};

export default values;
